import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=1f66a319&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"
import style0 from "./Prompt.vue?vue&type=style&index=0&id=1f66a319&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f66a319",
  null
  
)

export default component.exports